<template>
    <div class="settings">
        <Header :app="app" :left="true" title="Staff">
            <template v-slot:left>
                <a href="javascript:;" v-on:click="app.$router.push('/')">
                    &laquo;
                </a>
            </template>
        </Header>

        <div class="content">
            <div class="field">
                <table class="table passcodes no-hover">
                    <thead>
                        <tr>
                            <th class="with-padding">Name</th>
                            <th class="with-padding">PIN</th>
                            <th class="with-padding">Permissions</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="staff in app.sortedStaff" :key="staff.id">
                            <td>
                                <input type="text" v-model="staff.name" placeholder="Name" v-on:blur="app.save(staff)">
                            </td>
                            <td>
                                <input type="number" v-model="staff.pin" v-on:blur="changePin(staff)" class="align-center" min="0" max="99999999" maxlength="8" pattern="\d{4,8}" placeholder="0000">
                            </td>
                            <td class="with-padding">
                                <ul class="permissions">
                                    <li v-for="location in app.sortedLocations" :key="location.id">
                                        <label>
                                            <input type="checkbox" :checked="app.isPermitted(staff, location.id)" :disabled="app.isPermitted(staff, 'admin')" v-on:change="app.togglePermissions(staff, location.id)">
                                            {{location.name}}
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="checkbox" :checked="app.isPermitted(staff, 'admin')" :disabled="app.user.id === staff.id" v-on:change="app.togglePermissions(staff, 'admin')">
                                            Admin
                                        </label>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <a href="javascript:;" v-on:click="app.remove(app.staff, staff, 'staff member')" class="remove">&times;</a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br>

                <a v-if="!app.sortedStaff.length || app.isPaid" href="javascript:;" class="button" v-on:click.prevent="app.addStaff()">
                    + Add Staff
                </a>

                <a v-else href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=29U2LHYQNAURL" target="_blank" class="button">
                    Upgrade to Add More Staff!
                </a>

                <br><br>

                <p class="hint">*Admins have access to create, edit, and delete all Locations and Staff, as well as see detailed Reports.</p>
            </div>
        </div>
    </div>
</template>

<script>
import Header     from '@/components/header/component.vue';

export default {
    name: 'analytics',
    props: ['app'],
    components: {
        Header
    },
    methods: {
        changePin(staff) {
            var _ = this;

            if (_.app.sortedStaff.filter(function(s) {
                return s !== staff && s.pin + '' === staff.pin + '';
            }).length) {
                alert('The PIN is already taken.');
                staff.pin = _.app.generatePin();
                return;
            }

            _.app.save(staff, 'pin');
        }
    }
};
</script>
